<template>
   <div
       v-if="origin"
       style="text-align: center;"
    >
        <i
            class="fa fa-table"
            style="font-size: 30px;"
        />
    </div>
    <div
        v-else
        style="font-size: 14px; margin: -2px; padding: 2px;"
        @mousedown="triggerFocus($event, data.id)"
    >
        <div :style="getMargins()">
            <table
                ref="contentWrapper"
                width="100%"
            >
                <tr>
                    <td
                        align="center"
                        style="font-size: 0;"
                    >
                        <table 
                            v-for="(col, index) in data.columns"
                            :key="index"
                            class="column-table"
                            style="display: inline-table; vertical-align: inherit;border-spacing: 0px; border-collapse: collapse;" 
                            cellspacing="0"
                            cellpadding="0"
                            border="0" 
                            :width="col+'%'"
                            :style="{'verticalAlign': data.style && data.style.verticalAlign ? data.style.verticalAlign : 'middle'}"
                        >
                            <tr>
                                <td
                                    style="vertical-align:top; width: 100%;"
                                    :style="getCellStyle(index)"
                                >
                                    <container
                                        v-bind="{'tree': tree[index]}"
                                        :supports="[]"
                                        @update="update"
                                        @remove="remove"
                                        @focus="focus"
                                        @unfocus="unfocus"
                                        @dragstart="dragstart"
                                        @dragend="dragend"
                                    />
                                        <div
                                            v-if="(selected) && index > 0"
                                            class="cell-resize-handle control"
                                            @mousedown="startCellResize($event, index)"
                                        >
                                        <span class="fa fa-ellipsis-h" />
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
        <block-styles 
            v-if="(isEdited && selected)" 
            :data="data"
            :wrapper="$refs.contentWrapper"
            @change="updateStyles" 
            @init="updateStyles" 
        />
    </div>
</template>

<script>
    import ComponentMixin from './Component.vue'
    import BlockStyles from './BlockStyles.vue'

    export default {
        name: 'Columns',
        components: {'block-styles': BlockStyles},
        mixins: [ComponentMixin],
        props: {
            'bindedStyles': {
                type: Array,
                default: function () { return [
                    'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 
                    'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 
                ] }
            },
        },
        data: function(){
            return {
                resizeStartPos: null,
                resizeStartWidth: null,
                resizeCell: null,
                columnRatios: this.data.columns,
                selected: false,
            }
        },
        mounted: function() {
        },
        methods: {
            getCellStyle: function(index) {
                let left = this.data.style ? this.data.style.paddingLeft : '0px'; 
                let right = this.data.style ? this.data.style.paddingRight : '0px'; 

                if (this.data.columns.length > 1) {
                    if (index == 0) {
                        right = left;
                        left = '0px';
                    } else if (index == this.data.columns.length-1) {
                        left = right;
                        right = '0px';
                    }
                }

                return {
                    'paddingLeft': left, 
                    'paddingRight': right, 
                    'paddingTop': this.data.style ? this.data.style.paddingTop : '0px',
                    'paddingBottom': this.data.style ? this.data.style.paddingBottom : '0px'
                }
            },
            getMargins: function() {
                return {
                    'marginLeft': this.data.style ? this.data.style.marginLeft: '0px',
                    'marginRight': this.data.style ? this.data.style.marginRight: '0px',
                    'marginTop': this.data.style ? this.data.style.marginTop : '0px',
                    'marginBottom': this.data.style ? this.data.style.marginBottom : '0px',
                }
            },
            updateStyles: function(data) {
                this.update(this.data.id, {'style': data});
                this.$forceUpdate();
            },
            remove: function(id, event) {
                this.$emit('remove', id, event);
            },
            update: function(id, data, event) {
                this.$emit('update', id, data, event);
            },
            disableSelect: function(e) {
                e.preventDefault();
            },
            startCellResize: function(e, cellIndex) {
                this.resizeStartPos = e.clientX;
                this.columnRatios = this.data.columns;
                this.resizeStartWidth = this.columnRatios[cellIndex-1];
                this.resizeCell = cellIndex;
                document.addEventListener('mousemove', this.cellResize, true);
                document.addEventListener('mouseup', this.stopCellResize, true);
                document.addEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'col-resize';
            },
            stopCellResize: function() {
                this.resizeStartPos = null;
                this.resizeStartWidth = null;
                this.resizeCell = null;
                document.removeEventListener('mousemove', this.cellResize, true);
                document.removeEventListener('mouseup', this.stopCellResize, true);
                document.removeEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'auto';
                this.$emit('update', this.data.id, {'columns': this.columnRatios});
            },
            cellResize: function(e) {
                const delta = (e.clientX - this.resizeStartPos)/this.$parent.$el.clientWidth*100;
                const minWidth = 15; 
                const maxWidth = 100 - minWidth*(this.data.columns.length-1);

                let percent = Math.ceil(this.resizeStartWidth + delta);
                if (percent == 33) {
                    percent=33.33333333333;
                }
                let sum = 100; 

                if (percent > maxWidth) percent = maxWidth;
                if (percent < minWidth) percent = minWidth;

                for (let [index, columnWidth] of this.columnRatios.entries()) {
                    if (index == this.resizeCell-1) {
                        sum -= percent;
                    } else if (index == this.resizeCell) {
                        continue;
                    } else {
                        sum -= columnWidth;
                    }
                }

                if (sum < minWidth) {
                    percent = percent-(minWidth - sum);
                }

                this.columnRatios.splice(this.resizeCell-1, 1, percent)
                this.columnRatios.splice(this.resizeCell, 1, this.columnRatios[this.resizeCell] + 100 - this.columnRatios.reduce(function(a, b) { return a + b; }))

                //let containers = this.$children.filter(child => { return child.$options.name === 'container' });
                //let totalWidth = 0;

                //for (var container of containers) {
                    //totalWidth += container.$el.clientWidth;
                //}
            },
        }
    };
</script>

